import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Form, FormGroup, Input, Button } from 'reactstrap';
import { authenticate } from '../../redux';
import { Loader } from '..';

import './LoginForm.css';

import logo  from '../../assets/images/Kronos.svg';

const LoginForm = ({ hide_logo, appear, email_helper }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const [email, setEmail]       = useState('');
    const [password, setPassword] = useState('');

    const { logInErrorMessage, isAuthenticating, logInError } = useSelector(state => state.auth);

    const submit = e => {
        e.preventDefault();
        dispatch(authenticate(email, password));
    }

    return (
        <Form onSubmit={ submit } className={`LoginForm ${appear ? 'appear' : ''}`}>
            {!hide_logo && (
                <img className="logo" src={logo} alt="logo" />
            )}
            <FormGroup>
                <Input
                    required
                    type="email"
                    autoComplete="username email"
                    name="email"
                    id="email"
                    placeholder={t("login.email")}
                    value={ email }
                    onChange={ e => setEmail(e.target.value) }
                />
            </FormGroup>
            <FormGroup>
                <Input
                    required
                    type="password"
                    autoComplete="current-password"
                    name="password"
                    id="password"
                    placeholder={t("login.password")}
                    value={ password }
                    onChange={ e => setPassword(e.target.value) }
                />
            </FormGroup>

            <Button className="btn btn-lg btn-block btn-dark">
                {isAuthenticating ?
                    <span>
                        &nbsp;<i className="fa fa-spinner fa-spin"></i>
                    </span>
                    :
                    <span>{t('login.title')}</span>
                }
            </Button>

            {logInError &&
                <div>
                    <br/>
                    <div className="alert alert-danger">
                        <i className="fa fa-warning"></i>&nbsp;
                        {logInErrorMessage}
                    </div>
                </div>
            }

            {email_helper && (
            <>
                <div className="lost-password-helper-top">
                    { t('login.forgot_your_email_or_password') }
                </div>
                <div className="lost-password-helper-bottom">
                    { t('login.please_write_to') }&nbsp;
                    <a href={`mailto:${email_helper}`} target="_blank">
                        { email_helper }
                    </a>
                </div>
            </>
            )}
        </Form>
    );
}

export default LoginForm;
